import styled from "styled-components";

export const IconWrapper = styled.span`
  display: inline-block;
  & svg {
    width: 100%;
    height: 100%;
  }
`;
